import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import ec from "./ec";
import pe from "./pe";
import co from "./co";

const messages = {
  co,
  ec,
  pe,
};

const i18n = new VueI18n({
  locale: "pe", // set locale
  messages, // set locale messages
});

// Hot updates
if (module.hot) {
  module.hot.accept(["./ec", "./pe"], function() {
    i18n.setLocaleMessage("ec", require("./ec").default);
    i18n.setLocaleMessage("pe", require("./pe").default);

    // Or the following hot updates via $i18n property
    // app.$i18n.setLocaleMessage('en', require('./en').default)
    // app.$i18n.setLocaleMessage('ja', require('./ja').default)
  });
}

export default i18n;
